// Keep only navigation metadata, never cached journey content or visibility decisions.
const views = new Map();
const MAX_VIEWS = 10;
const TTL_MS = 30 * 60 * 1000;

export function readJourneyReturnState(key) {
  const state = key && views.get(key);
  if (!state || Date.now() - state.at > TTL_MS) return null;
  return state;
}

export function saveJourneyReturnState(key, count, scrollY) {
  if (!key || count <= 0) return;
  views.delete(key);
  views.set(key, { count, scrollY, at: Date.now() });
  while (views.size > MAX_VIEWS) views.delete(views.keys().next().value);
}
